(function (w, d, n) {
  if (!w[n]) {
    for (var i = w[n] = [], a = ["survey", "reset", "config", "init", "set", "get", "event", "identify", "track", "page", "screen", "group", "alias"], s = 0; s < a.length; s++) {
      var c = a[s];
      i[c] = i[c] || function (e) {
        return function () {
          var t = Array.prototype.slice.call(arguments);
          i.push([e, t])
        }
      }(c)
    }
    i.SNIPPET_VERSION = "1.0.1";
    var o = d.createElement("script");
    o.type = "text/javascript", o.async = !0, o.src = "https://d2yyd1h5u9mauk.cloudfront.net/integrations/web/v1/library/UoiUhsiIbiwSZhNT/delighted.js";
    var p = d.getElementsByTagName("script")[0];
    p.parentNode.insertBefore(o, p)
  }
})(window, document, "delighted");
